export type Job = {
  id: string;
  type: string;
  initiator: string;
  description: string;
  startTime: string;
  endTime: string;
  status: JobStatus;
  steps?: any;
};

export enum JobStatus {
  FAILED = 'FAILED',
  PENDING = 'PENDING',
  RUNNING = 'RUNNING',
  STOPPING = 'STOPPING',
  FINISHED = 'FINISHED',
  CANCELED = 'CANCELED',
  COMPLETED = 'COMPLETED',
  INTERRUPTED = 'INTERRUPTED',
}

